import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene.js';
import { LoginScene } from './scenes/LoginScene.js';
import { PendingScene } from './scenes/PendingScene.js';
import { AdminScene } from './scenes/AdminScene.js';
import { HallScene } from './scenes/HallScene.js';
import { LobbyScene } from './scenes/LobbyScene.js';
import { RoomScene } from './scenes/RoomScene.js';
import { GameScene } from './scenes/GameScene.js';
import { installKeyboardInset } from './ui/viewport.js';

// Mobile keyboard / focus handling for all chat inputs.
installKeyboardInset();

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  parent: 'game',
  backgroundColor: '#3d1418',
  scale: {
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH,
  },
  scene: [
    BootScene,
    LoginScene,
    PendingScene,
    AdminScene,
    HallScene,
    LobbyScene,
    RoomScene,
    GameScene,
  ],
};

const game = new Phaser.Game(config);

// On mobile an orientation change often fires the resize event BEFORE the
// viewport dimensions have settled, so Phaser's RESIZE canvas stays stuck at
// the old (portrait) size — the background then only fills part of the
// landscape screen (a vertical seam). Re-read the real size a few times as the
// rotation animation settles.
const refreshScale = (): void => {
  game.scale.refresh();
};
const settleRefresh = (): void => {
  refreshScale();
  [120, 320, 600].forEach((ms) => window.setTimeout(refreshScale, ms));
};
window.addEventListener('orientationchange', settleRefresh);
window.screen?.orientation?.addEventListener('change', settleRefresh);
